const navigatePath = (businessType: any, isHistory: boolean, id: any) => {
  let listType = isHistory ? "HISTORY" : "PROCEDURE";

  const path: any = {
    "JOB-01": {
      PROCEDURE: "/SCRC030102",
      HISTORY: "/SCRC060007",
    },
    "JOB-02": {
      PROCEDURE: "/SCRC050106",
      HISTORY: "/SCRC050009",
    },
    "JOB-03": {
      PROCEDURE: "/SCRC050110",
      HISTORY: "/SCRC050012",
    },
    "JOB-04": {
      PROCEDURE: "/SCRC050113",
      HISTORY: "/SCRC050016",
    },
    "JOB-05": {
      PROCEDURE: "/SCRC040002",
      HISTORY: "/SCRC040002",
    },
    "JOB-06": {
      PROCEDURE: "/SCRC040002",
      HISTORY: "/SCRC040002",
    },
    "JOB-07": {
      PROCEDURE: "/SCRC040103",
      HISTORY: "/SCRC040004",
    },
    "JOB-08": {
      PROCEDURE: "/SCRC040103",
      HISTORY: "/SCRC040004",
    },
    "JOB-09": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-10": {
      PROCEDURE: "/SCRC060112",
      HISTORY: "/SCRC060112",
    },
    "JOB-11": {
      PROCEDURE: "/SCRC080001",
      HISTORY: "/SCRC080006",
    },
    "JOB-12": {
      PROCEDURE: "/SCRC080009",
      HISTORY: "/SCRC080009",
    },
    "JOB-13": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-14": {
      PROCEDURE: "/SCRC070105",
      HISTORY: "/SCRC070105",
    },
    "JOB-15": {
      PROCEDURE: "/SCRC050101",
      HISTORY: "/SCRC070104",
    },
    "JOB-16": {
      PROCEDURE: "/SCRC050125",
      HISTORY: "/SCRC050028",
    },
    "JOB-17": {
      PROCEDURE: "/SCRC050017",
      HISTORY: "/SCRC050017",
    },
    "JOB-18": {
      PROCEDURE: "/SCRC050120",
      HISTORY: "/SCRC050024",
    },
    "JOB-19": {
      PROCEDURE: "/SCRC050017",
      HISTORY: "/SCRC050017",
    },
    "JOB-20": {
      PROCEDURE: "/SCRC050029",
      HISTORY: "/SCRC050029",
    },
    "JOB-21": {
      PROCEDURE: "/SCRC050018",
      HISTORY: "/SCRC050018",
    },
    "JOB-22": {
      PROCEDURE: "/SCRC050019",
      HISTORY: "/SCRC050019",
    },
    "JOB-23": {
      PROCEDURE: id ? "/SCRC060108" : "/SCRC070007",
      HISTORY: "/SCRC060110",
    },
    "JOB-24": {
      PROCEDURE: "/SCRC060112",
      HISTORY: "/SCRC060112",
    },
    "JOB-25": {
      PROCEDURE: id ? "/SCRC060112" : "/SCRC070007",
      HISTORY: "/SCRC060112",
    },
    "JOB-26": {
      PROCEDURE: id ? "/SCRC060116" : "/SCRC070007",
      HISTORY: "/SCRC060116",
    },
    "JOB-27": {
      PROCEDURE: id ? "/SCRC060103" : "/SCRC070007",
      HISTORY: "/SCRC060103",
    },
    "JOB-28": {
      PROCEDURE: "/SCRC060013",
      HISTORY: "/SCRC060013",
    },
    "JOB-29": {
      PROCEDURE: "/SCRC060013",
      HISTORY: "/SCRC060013",
    },
    "JOB-30": {
      PROCEDURE: "/SCRC060108",
      HISTORY: "/SCRC060110",
    },
    "JOB-31": {
      PROCEDURE: "/SCRC060118",
      HISTORY: "/SCRC060026",
    },
    "JOB-32": {
      PROCEDURE: "/SCRC070007",
      HISTORY: "/SCRC060026",
    },
    "JOB-33": {
      PROCEDURE: "/SCRC060118",
      HISTORY: "/SCRC060028",
    },
    "JOB-34": {
      PROCEDURE: "/SCRC060132",
      HISTORY: "/SCRC060132",
    },
    "JOB-35": {
      PROCEDURE: "/SCRR411102",
      HISTORY: "/SCRR410016",
    },
    "JOB-36": {
      PROCEDURE: "/SCRR411102",
      HISTORY: "/SCRR410017",
    },
    "JOB-37": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-38": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-39": {
      PROCEDURE: "/SCRR410028",
      HISTORY: "/SCRR410028",
    },
    "JOB-40": {
      PROCEDURE: "/SCRR411119",
      HISTORY: "/SCRR410022",
    },
    "JOB-41": {
      PROCEDURE: "/SCRR410003",
      HISTORY: "/SCRR410027",
    },
    "JOB-42": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-43": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-44": {
      PROCEDURE: "/SCRC070206",
      HISTORY: "/SCRC070206",
    },
    "JOB-45": {
      PROCEDURE: "/SCRC090002",
      HISTORY: "",
    },
    "JOB-46": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-47": {
      PROCEDURE: "/SCRC060134",
      HISTORY: "/SCRC060134",
    },
    "JOB-48": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-49": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-50": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-51": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-52": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-53": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-54": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-55": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-56": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-57": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-58": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-59": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-60": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-61": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-62": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-63": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-64": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-65": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-66": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-67": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-68": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-69": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-70": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-71": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-72": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-73": {
      PROCEDURE: "",
      HISTORY: "/SCRC030001",
    },
    "JOB-74": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-75": {
      PROCEDURE: "/SCRC070105",
      HISTORY: "/SCRC070105",
    },
    "JOB-76": {
      PROCEDURE: "/SCRC010004",
      HISTORY: "/SCRC010004",
    },
    "JOB-77": {
      PROCEDURE: "",
      HISTORY: "/SCRR410016",
    },
    "JOB-78": {
      PROCEDURE: "",
      HISTORY: "",
    },
    "JOB-79": {
      PROCEDURE: "/SCRC080007",
      HISTORY: "/SCRC080007",
    },
    "JOB-80": {
      PROCEDURE: "/SCRC080008",
      HISTORY: "",
    },
    "JOB-130": {
      PROCEDURE: "/SCRC060031",
      HISTORY: "/SCRC060026",
    },
  };

  return path[businessType][listType];
};

export { navigatePath };
